<template>
    <div style="margin-bottom: 10px;">
    <div class="d-flex align-items-start justify-content-center" style="height: 50vh;">
    <b-card cols="6" class="w-100" >
      <b-col cols="6" class="mb-2">
        
      </b-col>
      
      <b-col md="12" v-if="this.insumo.nombre">
        <b-form-group>
          <i class="fas fa-tag" style="margin-right: 10px;"></i>
          <span>Nombre: {{ insumo.nombre }}</span>
        </b-form-group>
      </b-col>
  
      <b-col md="12" v-if="this.insumo.codigo">
        <b-form-group>
          <i class="fas fa-barcode" style="margin-right: 10px;"></i>
          <span>Codigo: {{ insumo.codigo }}</span>
        </b-form-group>
      </b-col>

      <b-col md="12" v-if="this.insumo.presentacion">
        <b-form-group>
          <i class="fas fa-dollar-sign" style="margin-right: 10px;"></i>
          <span>Presentacion: {{ insumo.presentacion }}</span>
        </b-form-group>
      </b-col>
  
      <b-col md="12" v-if="this.insumo.precioNeto">
        <b-form-group>
          <i class="fas fa-dollar-sign" style="margin-right: 10px;"></i>
          <span>Precio: {{ insumo.precioNeto }}</span>
        </b-form-group>
      </b-col>
  
      
  
      <b-col md="12" v-if="this.insumo.estado">
        <b-form-group>
          <i class="fas fa-toggle-on" style="margin-right: 10px;"></i>
          <span>Estado : {{ insumo.estado }}</span>
        </b-form-group>
      </b-col>
    </b-card>
  </div>
</div>
  </template>
<script>
  
  import axios from 'axios';
  import rutas from '@/assets/utils/rutas.json';
  import { BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput } from 'bootstrap-vue';
  
  
  export default {
    components: {
      BContainer,
      BRow,
      BCol,
      BCard,
      BForm,
      BFormGroup,
      BFormInput,
      
    },
    props: ['token'],

    data() {
      return {
        insumo: {
          id: '',
          token: '',
          nombre: '',
          codigo: '',
          presentacion: '',
          precioNeto: 0,
          establecimiento: '',
          estado: 0,
        },
      };
    },
    created() {
    
      // const tokenmedicamento = this.$route.params.token;
      
      this.fetchConsultarinsumo();
    },
    methods: {
      
        
        async fetchConsultarinsumo(search = '', pagina_actual = 1, establecimiento = '', pageSize ) {

const query = `
query GetAllinsumos($tokenInsumo: String, $search: String, $establecimiento: String, $page: Int, $pageSize: Int) {
    allInsumos(tokenInsumo: $tokenInsumo, search: $search, establecimiento: $establecimiento, page: $page, pageSize: $pageSize) {
        total
        status
        message
        insumos {
            id
            token
            nombre
            codigo
            establecimiento {
                id
                Descripcion
            }
            usuarioCreador {
                id
                username
            }

            precioNeto
            precioTecho
            numMax
        }
        pageInfo {
            currentPage
            totalPages
            hasNextPage
            hasPreviousPage
        }
    }
}
`;
const tokenInsumo = this.token 

const var_consulta = {
    search: search,
    page: pagina_actual,
    pageSize: pageSize,
    tokenInsumo : tokenInsumo, 
    establecimiento: establecimiento.toString()
}
try {
    console.log("llegamos otra vez")
    const response = await axios.post(rutas.axios + 'api', { query, variables: var_consulta });
    console.log(response)
    console.log("llegamos otra vez2")

    if (response.status === 200) {
        if (response.data.data.allInsumos.status === 'Success') {
            if (response.data.data.allInsumos.insumos) {
                let variable = response.data.data.allInsumos.insumos
                console.log("esto contiene variable", variable)
                this.insumo = response.data.data.allInsumos.insumos[0]
                console.log("este es el insumo que encontro", this.insumo)
                console.log("yey",this.items);

                this.totalRows = response.data.data.allInsumos.total;
                this.currentPage = 1;
                this.currentPageModificado = pagina_actual
            } else {
                console.log("No se encontraron insumos");
                // Aquí podrías establecer un mensaje en la interfaz de usuario
            }
        } else {
            console.log("Error en la respuesta del servidor");
            // Manejo del error de respuesta del servidor
        }
    }
} catch (error) {
    console.error("Error fetching insumos:", error);
    // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
}
},
    
    }
  };
  </script>
  